import React, { useState, useEffect } from "react";
import Logo from "../../assets/img/custom/logo.png";
import SuccessImage from "../../assets/img/custom/profileEdit.png";
import firebase from "../../config/firebase";
import {
  Label,
  Input,
  Button,
  Form,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { Link, Redirect, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { registerSuccess, login } from "store/actions/authActions";

function Login() {
  const location = useLocation();
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("success") === "true") {
      setModalOpen(true);
    }

    dispatch(registerSuccess());
  }, [dispatch, location.search]);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(login({ email, password }));
  };

  if (auth.uid) {
    const currentUser = firebase.auth().currentUser;
    if (currentUser && !currentUser.emailVerified) {
      return <Redirect to="/auth/email-verification-pending" />;
    }
    return <Redirect to="/admin/index" />;
  }

  return (
    <>
      <div className="text-center mt-5">
        <Link to="/">
          <img src={Logo} alt="logo" className="logo" />
        </Link>
      </div>

      <Form onSubmit={handleSubmit}>
        <div className="auth-card">
          <h2 className="auth-heading">Athlete Login</h2>

          <Label className="mt-3 auth-label">
            <b>Email</b>
          </Label>
          <Input
            required
            placeholder="name@gmail.com"
            type="email"
            className="custom-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <Label className="mt-5 auth-label">
            <b>Password</b>
          </Label>
          <Input
            required
            type="password"
            placeholder="Your Password"
            className="custom-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <div className="d-flex mt-4">
            <Label className="ml-auto auth-label">
              <Link to="/auth/forgot-password">
                <u>Forgot Password?</u>
              </Link>
            </Label>
          </div>
        </div>

        <div className="text-center">
          <Button disabled={!email || !password} className="auth-button mt-5">
            {auth.loading ? <Spinner size="sm" /> : "Log In"}
          </Button>
        </div>
      </Form>

      <div className="mt-3 mx-0 mx-md-5 text-center">
        <Label className="auth-label">Don't have an account yet?</Label>{" "}
        <Link to="/auth/register">
          <Label
            className="text-primary auth-label"
            style={{ cursor: "pointer" }}
          >
            <b>
              <u>Sign Up</u>
            </b>
          </Label>
        </Link>
      </div>

      <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)}>
        <ModalHeader toggle={() => setModalOpen(false)}>
          Info Edit Profile
        </ModalHeader>
        <ModalBody className="text-center">
          <img src={SuccessImage} alt="Success" style={{ width: "100%" }} />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setModalOpen(false)}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default Login;
